import { lazy } from "react";

export { DISK_SPACE_PATH } from "./disk-space-path";
export const DiskSpacePage = lazy(() => import("./disk-space"));
